import { jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import get from 'lodash.get';
import React, { useEffect } from 'react';
import { Anchor } from '@mirohq-internal/website-ui-foundation';

const toggleOneTrust = (event)=>{
    const toggleInfoDisplay = get(window, 'OneTrust.ToggleInfoDisplay');
    if (!toggleInfoDisplay) {
        return;
    }
    event.preventDefault();
    toggleInfoDisplay?.();
};
const LegalHub = ({ legalHubLinks })=>{
    const [isInUS, setIsInUS] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    useEffect(()=>{
        const intervalOneTrust = setInterval(()=>{
            if (typeof window.OneTrust?.getGeolocationData === 'function') {
                clearInterval(intervalOneTrust);
                const geoLocationData = window.OneTrust.getGeolocationData();
                setIsInUS(`${geoLocationData.country}`.toUpperCase() === 'US');
                setLoading(false);
            }
        }, 100);
        return ()=>{
            clearInterval(intervalOneTrust);
        };
    }, []);
    return jsx(Fragment, {
        children: legalHubLinks.map((link)=>{
            if (!isInUS && link.href.includes('ccpa')) {
                return null;
            }
            return jsx(Anchor, {
                href: link.href,
                className: classNames('fade fade-in text-tertiary', {
                    show: !loading
                }),
                onClick: link?.withOneTrust ? toggleOneTrust : undefined,
                children: jsx("span", {
                    className: "d-block text-wrap text-center",
                    children: link.title
                })
            }, link.href);
        })
    });
};

export { LegalHub };
